import {Component} from '@angular/core';
import {AlertService, IAlert} from '@shared/services/alert.service';

@Component({
  selector: 'app-alert-list',
  templateUrl: './alert-list.component.html',
  styleUrls: ['./alert-list.component.css']
})
export class AlertListComponent {

  constructor(public alertService: AlertService) { }

  close(alert: IAlert) {
    this.alertService.close(alert);
  }

}
